import { render, staticRenderFns } from "./vpd-phone-input.vue?vue&type=template&id=5ce529ed&scoped=true"
import script from "./vpd-phone-input.vue?vue&type=script&lang=js"
export * from "./vpd-phone-input.vue?vue&type=script&lang=js"
import style0 from "./vpd-phone-input.vue?vue&type=style&index=0&id=5ce529ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce529ed",
  null
  
)

export default component.exports